const t = {
  name: "Terminal1",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 16.25C11.31 16.25 10.75 15.69 10.75 15C10.75 14.31 11.31 13.75 12 13.75C12.69 13.75 13.25 14.31 13.25 15C13.25 15.69 12.69 16.25 12 16.25Z" fill="currentColor"/>
<path d="M5 3C5 1.35 6.35 0 8 0H16C17.65 0 19 1.35 19 3V17C19 18.65 17.65 20 16 20H8C6.35 20 5 18.65 5 17V3ZM7 3V10H17V3C17 2.45 16.55 2 16 2H8C7.45 2 7 2.45 7 3ZM17 12H7V17C7 17.55 7.45 18 8 18H16C16.55 18 17 17.55 17 17V12Z" fill="currentColor"/>
<path d="M7 24V22H17V24H7Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Terminal1
};
